import common from './common.json'
import customerManagement from './customerManagement.json'
import inspection from './inspection.json'
import productDuplication from './productDuplication.json'
import productManagement from './productManagement.json'
import productSetting from './productSetting.json'
import questionnaire from './questionnaire.json'
import reservationChange from './reservationChange.json'
import reservationManagement from './reservationManagement.json'
import reservationRegister from './reservationRegister.json'
import appReflection from 'locales/jp/appReflection.json'
import basicSetting from 'locales/jp/basicSetting.json'
import chat from 'locales/jp/chat.json'
import consultant from 'locales/jp/consultant.json'
import consultationReport from 'locales/jp/consultationReport.json'
import courseRegister from 'locales/jp/courseRegister.json'
import csvImportResults from 'locales/jp/csvImportResults.json'
import customerDetail from 'locales/jp/customerDetail.json'
import customerRegister from 'locales/jp/customerRegister.json'
import errors from 'locales/jp/errors.json'
import patientDetail from 'locales/jp/patientDetail.json'
import prefectures from 'locales/jp/prefectures.json'
import questionnaireResultCreate from 'locales/jp/questionnaireResultCreate.json'
import scenarioData from 'locales/jp/scenarioData.json'
import scenarioList from 'locales/jp/scenarioList.json'

const listTranslationJp = {
  ...common,
  ...courseRegister,
  ...{ customerManagement },
  ...{ customerDetail },
  ...{ customerRegister },
  ...{ basicSetting },
  ...{ qrc: questionnaireResultCreate },
  ...{ consultant },
  ...questionnaire,
  ...inspection,
  ...errors,
  ...{ reservationManagement },
  ...{ reservationRegister },
  ...{ productManagement },
  ...{ productSetting },
  ...{ reservationChange },
  ...{ productDuplication },
  ...patientDetail,
  ...scenarioList,
  ...{ consultationReport },
  ...{ csvImportResults },
  ...{ appReflection },
  prefectures,
  ...chat,
  ...scenarioData
}

export default listTranslationJp
